import { Button, Tooltip, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";

import { starPatient } from "../../api/api";
import { BLACK, WHITE, GRAY_400, GRAY_500 } from "../../constant/colors";
import { selectPatientDetails } from "../../store/selector";
import ErrorMessage from "../customComponent/customMessages/ErrorMessage";
import ACTIONS from "../../store/action";
import { fontWeights, sizes } from "../../constant/styles";
import ActiveStarIcon from "../../assets/svg/ActiveStarIcon";
import InActiveStarIcon from "../../assets/svg/InActiveStarIcon";

const { Text } = Typography;

const PatientStarComponant = ({
  t,
  setPatientTableRecordDataAct,
  patientId,
  patientDetails,
  height = 12,
  width = 12
}) => {
  const [isFetching, setIsFetching] = useState(false);
  const [isStarred, setIsStarred] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    setIsStarred(patientDetails?.starred);
  }, [patientDetails?.starred]);

  const title = t(isStarred ? "favorite" : "mark_as_favorite");

  const handleStarPatient = async () => {
    setIsFetching(true);
    try {
      const response = await starPatient(patientId, !isStarred);
      if (response && response.data && response.data.success) {
        setPatientTableRecordDataAct(patientId, { starred: !isStarred });
        setIsStarred(!isStarred);
      } else {
        ErrorMessage(t("errorMessages.patient_starred"));
      }
    } catch (error) {
      ErrorMessage(t("errorMessages.patient_starred"));
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <Button type="text" disabled={isFetching} onClick={handleStarPatient} style={{ padding: 0, height, width }}>
      <Tooltip
        title={<Text style={{ color: BLACK, fontSize: sizes.small, fontWeight: fontWeights.semibold }}>{title}</Text>}
        color={WHITE}
      >
        <div
          style={{
            minWidth: 18,
            minHeight: 18
          }}
          id="patient_star_icon_header"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isStarred ? <ActiveStarIcon /> : <InActiveStarIcon color={isHovered ? GRAY_500 : GRAY_400} />}
        </div>
      </Tooltip>
    </Button>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updatePatientDetailsAct: (patientDetails) => dispatch(ACTIONS.updatePatientDetailsAction(patientDetails)),
  setPatientTableRecordDataAct: (patientId, sharedFields) =>
    dispatch(ACTIONS.setPatientTableRecordData(patientId, sharedFields))
});

const mapStateToProps = createStructuredSelector({
  patientDetails: selectPatientDetails
});

const PatientStar = compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(PatientStarComponant);

export { PatientStar };
